/**
 * @filedesc: 阿里云逻辑
 */

const URL = {
  aliyunDominUrl: process.env.VUE_APP_MEDIA_DOMIN + '/' // 环境变量,多媒体域名
}

class Aliyun {
  /**
   * ali云os地址拼接---图片、视频
   * @param value oss地址
   */
  getAliyunAddress (value) {
    let result
    if (!value) return false
    if (value.match(/http/gi) || value.indexOf('data:image') > -1 || (process.env.NODE_ENV === 'development' && value.indexOf('static') > -1)) {
      result = value
    } else {
      if (process.env.VUE_APP_MEDIA_DOMIN === 'https://h5.kmaxredcloud.com') {
        result = 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/' + value
      } else {
        result = URL.aliyunDominUrl + value
      }
    }
    return result
  }
  /**
   * ali云os地址拼接---模型
   * @param value oss地址
   */
  getAliOsUrlModel (value) {
    let result
    if (!value) return false
    if (value.match(/http/gi) || value.indexOf('data:image') > -1 || (process.env.NODE_ENV === 'development' && value.indexOf('static') > -1)) {
      result = value
    } else if (process.env.NODE_ENV === 'production') {
      result = 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/' + value // 正式
    } else {
      // result = 'https://partybuildingplatformtest.oss-cn-shanghai.aliyuncs.com/' + value // 测试
      result = 'https://static-test.kmaxredcloud.com/' + value
    }
    return result
  }
}

export default new Aliyun()
